export const visit = (vm, at) => {
vm(require("documents-lib/lang/view/ru.lyaml"));
at({ "ru": { "public": { "sampleString": "\u041F\u0440\u0438\u043C\u0435\u0440 \u0441\u0442\u0440\u043E\u043A\u0438" } } });
};